import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SwitchTabs from '../common/SwitchTabs/SwitchTabs';
import ElectionWrapper from '../assembly/ElectionWrapper';
// import LokSabhaElectionWrapper from '../lokSabha/LokSabhaElectionWrapper';
import s from './ElectionWidgetMainWrapper.scss';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
// import USElectionWrapper from '../usElection/USElectionWrapper/USElectionWrapper';

const ElectionWidgetMainWrapper = ({
  isWapView,
  isHomePage,
  isPowerByAd,
  isPowerByAdActive,
  tabs,
  hideStarCandidate,
  hideLiveblog,
  hideHeading,
  hideDisplayText,
  hideSharing,
  hideTitle,
  hideLink,
  hideInfocus,
  // hidePowerStates,
  electionV2Interval,
  // usElectionInterval,
  lokSabhaInterval,
  isInnerWidget,
  bgColor,
  bgColorOuter,
  hideETheading,
  isIframeCssRequired,
  lokSabhaExit,
  electionwdtWap,
  wgtclient,
  // inpageminitvoff,
  // isUShomepage,
}) => {
  useEffect(
    () => {
      const importCssFiles = () => {
        if (isIframeCssRequired) {
          import('../../../scss_v2/base/_base.scss').then();
          import('../../../components_v2/desktop/Layout/Layout.scss').then();
        }
      };
      importCssFiles();
    },
    [isIframeCssRequired],
  );

  const [active, setActive] = useState(
    tabs && Array.isArray(tabs) && tabs.length > 0 ? tabs[0]?.index : 1,
  );
  const tabHandler = tab => {
    const activeTab = tab?.index || 1;
    setActive(activeTab);
  };

  return (
    <div
      className={`${s.electionWidgetMainWrapper} ${
        isInnerWidget ? 'innerPageElectionWidget' : ''
      } ${lokSabhaExit ? 'innerPageExitPollWidget' : ''}`}
    >
      {tabs &&
        Array.isArray(tabs) &&
        tabs.length > 1 &&
        electionV2Interval &&
        lokSabhaInterval && (
          <>
            <div
              className={`flexCenter ${
                isHomePage && !isWapView ? s.switchTabsWrap : ''
              }`}
            >
              <SwitchTabs tabs={tabs} tabHandler={tabHandler} isToggle />
            </div>

            {/* eslint-disable-next-line eqeqeq */}
            {active == 2 && (
              <ErrorBoundary>
                <ElectionWrapper
                  isWapView={isWapView}
                  key="electionData"
                  isPowerByAd={isPowerByAd}
                  isPowerByAdActive={isPowerByAdActive}
                  hideStarCandidate={hideStarCandidate}
                  hideLiveblog={hideLiveblog}
                  hideHeading={hideHeading}
                  hideSharing={hideSharing}
                  hideTitle={hideTitle}
                  hideLink={hideLink}
                  hideInfocus={hideInfocus}
                  hideDisplayText={hideDisplayText}
                  bgColor={bgColor}
                  bgColorOuter={bgColorOuter}
                  hideETheading={hideETheading}
                  electionwdtWap={electionwdtWap}
                  wgtclient={wgtclient}
                />
              </ErrorBoundary>
            )}
            {/* eslint-disable-next-line eqeqeq */}
            {/* {active == 1 && (
              <ErrorBoundary>
                <LokSabhaElectionWrapper
                  isWapView={isWapView}
                  key="loksabhaElectionData"
                  isPowerByAd={isPowerByAd}
                  isPowerByAdActive={isPowerByAdActive}
                  hideStarCandidate={hideStarCandidate}
                  hideLiveblog={hideLiveblog}
                  hideHeading={hideHeading}
                  hideSharing={hideSharing}
                  hideTitle={hideTitle}
                  hideLink={hideLink}
                  hideInfocus={hideInfocus}
                  hideDisplayText={hideDisplayText}
                  hidePowerStates={hidePowerStates}
                  bgColor={bgColor}
                  bgColorOuter={bgColorOuter}
                  hideETheading={hideETheading}
                  electionwdtWap={electionwdtWap}
                  wgtclient={wgtclient}
                  inpageminitvoff={inpageminitvoff}
                />
              </ErrorBoundary>
            )} */}
          </>
        )}
      {tabs &&
        Array.isArray(tabs) &&
        tabs.length === 1 && (
          <>
            {/* eslint-disable-next-line eqeqeq */}
            {/* {active == 3 &&
              usElectionInterval && (
                <ErrorBoundary>
                  <USElectionWrapper
                    isWapView={isWapView}
                    key="electionData"
                    isPowerByAd={isPowerByAd}
                    isPowerByAdActive={isPowerByAdActive}
                    hideStarCandidate={hideStarCandidate}
                    hideLiveblog={hideLiveblog}
                    hideHeading={hideHeading}
                    hideSharing={hideSharing}
                    hideTitle={hideTitle}
                    hideLink={hideLink}
                    hideInfocus={hideInfocus}
                    hideDisplayText={hideDisplayText}
                    bgColor={bgColor}
                    bgColorOuter={bgColorOuter}
                    hideETheading={hideETheading}
                    electionwdtWap={electionwdtWap}
                    wgtclient={wgtclient}
                    inpageminitvoff={inpageminitvoff}
                    isUShomepage={isUShomepage}
                  />
                </ErrorBoundary>
              )} */}

            {/* eslint-disable-next-line eqeqeq */}
            {active == 2 &&
              electionV2Interval && (
                <ErrorBoundary>
                  <ElectionWrapper
                    isWapView={isWapView}
                    key="electionData"
                    isPowerByAd={isPowerByAd}
                    isPowerByAdActive={isPowerByAdActive}
                    hideStarCandidate={hideStarCandidate}
                    hideLiveblog={hideLiveblog}
                    hideHeading={hideHeading}
                    hideSharing={hideSharing}
                    hideTitle={hideTitle}
                    hideLink={hideLink}
                    hideInfocus={hideInfocus}
                    hideDisplayText={hideDisplayText}
                    bgColor={bgColor}
                    bgColorOuter={bgColorOuter}
                    hideETheading={hideETheading}
                    electionwdtWap={electionwdtWap}
                    wgtclient={wgtclient}
                  />
                </ErrorBoundary>
              )}

            {/* eslint-disable-next-line eqeqeq */}
            {/* {active == 1 &&
              lokSabhaInterval && (
                <ErrorBoundary>
                  <LokSabhaElectionWrapper
                    isWapView={isWapView}
                    key="loksabhaElectionData"
                    isPowerByAd={isPowerByAd}
                    isPowerByAdActive={isPowerByAdActive}
                    hideStarCandidate={hideStarCandidate}
                    hideLiveblog={hideLiveblog}
                    hideHeading={hideHeading}
                    hideSharing={hideSharing}
                    hideTitle={hideTitle}
                    hideLink={hideLink}
                    hideInfocus={hideInfocus}
                    hideDisplayText={hideDisplayText}
                    hidePowerStates={hidePowerStates}
                    bgColor={bgColor}
                    bgColorOuter={bgColorOuter}
                    hideETheading={hideETheading}
                    electionwdtWap={electionwdtWap}
                    wgtclient={wgtclient}
                  />
                </ErrorBoundary>
              )} */}
          </>
        )}
    </div>
  );
};
ElectionWidgetMainWrapper.propTypes = {
  hideStarCandidate: PropTypes.bool,
  hideLiveblog: PropTypes.bool,
  hideHeading: PropTypes.bool,
  hideSharing: PropTypes.bool,
  hideTitle: PropTypes.bool,
  hideLink: PropTypes.bool,
  hideInfocus: PropTypes.bool,
  hideDisplayText: PropTypes.bool,
  // hidePowerStates: PropTypes.bool,
  isInnerWidget: PropTypes.bool,
  bgColor: PropTypes.string,
  bgColorOuter: PropTypes.string,
  electionwdtWap: PropTypes.string,
  wgtclient: PropTypes.string,
};
ElectionWidgetMainWrapper.defaultProps = {
  hideStarCandidate: false,
  hideLiveblog: false,
  hideHeading: false,
  hideSharing: false,
  hideTitle: false,
  hideLink: false,
  hideInfocus: false,
  hideDisplayText: false,
  // hidePowerStates: false,
  isInnerWidget: false,
  electionwdtWap: false,
  bgColor: '',
  bgColorOuter: '',
  wgtclient: '',
};

const mapStateToProps = state => ({
  electionV2Interval: state?.electionV2?.refreshinterval,
  lokSabhaInterval: state?.lokSabhaElection?.refreshinterval,
  usElectionInterval: state?.usElection?.refreshinterval,
  lokSabhaExit: state?.lokSabhaElection?.isExitPoll,
});

export default connect(mapStateToProps)(ElectionWidgetMainWrapper);
